<mp-root-module-nav *mpHeaderElement="'left'" label="Industriekataloge" />

<div class="mp-page mp-page--scrollable-wide-view mp-page--border">
  <div class="mp-page__main">
    <ng-container *ngrxLet="filter$ as filter">
      <div class="mp-page__aside mp-page--padding">
        <mp-industriekataloge-filter-area
          [searchTerm]="filter.searchTerm ?? ''"
          [selectedOpenTasks]="filter.openTasks || []"
          [dataSources]="(industryCatalogsDatasource$ | async) ?? []"
          [selectedDataSources]="filter.datasources || []"
          (filterChanges)="handleFilterChanges($event)"
          (searchTermChanged)="handleSearchTermChanges($event)"
        />
      </div>

      <div
        class="mp-page__content mp-page--padding"
        mpRestoreScrolling
        [hasLazyTrigger]="true"
        itemKey="mp-industriekataloge-list"
      >
        @if (hasManageIndustryCatalogsPermission()) {
          <mp-freigabe-queue [fetchCallback]="queueFetcher" (dataChanged)="getIndustryCatalogsDatasources()" />
        }

        @if ((isLoading$ | async) === false) {
          <ng-container *ngrxLet="pagination$ as pagination">
            <div class="list-header">
              <mp-list-header
                class="mp-list-header--spaced"
                headerPlaceholder="Industriekataloge"
                [totalItemsQuantity]="pagination.totalRowCount"
              >
                <mat-icon class="list-header__icon material-icons-outlined" list-header-prefix>factory</mat-icon>

                @if (hasManagePlatformPackagingUnitsPermission()) {
                  <mp-packungseinheiten-dialog
                    [einheiten$]="dataSourcePackungseinheiten$"
                    [einheitenPagination$]="dataSourcePackagingUnitPagination$"
                    [optionen]="(plattformPackungseinheiten$ | async) ?? []"
                    [datasources]="(datasources$ | async) ?? []"
                  />
                }
              </mp-list-header>

              <mp-dropdown
                class="list-header__sort"
                [options]="sortCriteriaOptions"
                label="Sortiere nach:"
                [selectedValue]="filter.sortCriteria"
                (selectedValueChange)="handleSortCriteriaChanges($event)"
              />
            </div>

            @for (catalog of kataloge(); track catalog.catalogId) {
              <mpcm-industry-catalog-card
                class="catalog-card"
                mpRestoreScrollingTrigger
                [catalog]="catalog"
                [canWrite]="hasManageIndustryCatalogsPermission()"
                [platformSuppliers]="platformSuppliers()"
                (supplierSearchTermChanges)="handleSupplierSearchTermChanges($event)"
                (saveClick)="updateKatalog(catalog.catalogId, $event)"
                (catalogDetailsClick)="navigateToIndustriekatalogDetail($event)"
              />
            }

            <mp-paginator [pagination]="pagination" (page)="getNextPage($event)" />
          </ng-container>
        } @else {
          <mp-spinner />
        }
      </div>
    </ng-container>
  </div>
</div>
